import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { BasePageComponent } from "../base-page/base-page.component";
import { HeaderAction, EntitySummaryTableData, HeaderCard } from "./entity-page.model";

@Component({
  selector: 'ntx-entity-page',
  templateUrl: './entity-page.component.html',
  styleUrls: ['./entity-page.component.scss']
})
export class EntityPageComponent<T> extends BasePageComponent<T> {
  @Input() entity: T;
  @Input() headerCards: HeaderCard[] = [];
  @Input() entitySummary: EntitySummaryTableData;
  @Input() title: string;
  @Input() actions: HeaderAction[]
}
